export default "{\n    \"inputPlaceholder\": \"Escriba su mensaje\",\n    \"uploadFileLabel\": \"Cargar desde dispositivo\"\n}\n"